import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { AuthenticationService } from './services/authentication.service';
import { BackButtonService } from './services/back-button.service';
import { GetQuoteDetailsService } from './services/get-quote-details.service';
import { GoogleAnalyticsEventsService } from './services/google-analytics-events.service';
import { SharedDataService } from './services/shared-data.service';
import { CookieService } from 'ngx-cookie-service';

/** Add Access to Session & Local Storage */
import { NgxWebstorageModule } from 'ngx-webstorage';

@NgModule({
  imports: [CommonModule, NgxWebstorageModule.forRoot({ prefix: '', separator: '', caseSensitive: true })],
  declarations: [],
  providers: [
    AuthenticationService,
    BackButtonService,
    GetQuoteDetailsService,
    GoogleAnalyticsEventsService,
    SharedDataService,
    CookieService,
  ],
})
export class CoreModule {}
